import { NET_REVENUE_INFO } from '@/api';
import type { Ytd } from '@/api';
import { InfoTooltip, KpiCard, KpiSkeleton } from '@/components';
import { Box, Flex } from '@blockanalitica/ui';

interface YtdKpisProps {
  data?: Ytd;
}

export default function YtdKpis({ data }: YtdKpisProps) {
  if (!data) {
    return (
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <KpiSkeleton />
        <KpiSkeleton />
        <KpiSkeleton />
        <KpiSkeleton />
      </Flex>
    );
  }

  const ytdLabel = `${data.year} YTD`;
  const currencyOptions = { currency: 'USD', notation: 'compact' as const };

  return (
    <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
      <KpiCard
        title={`Gross Revenue ${ytdLabel}`}
        field="gross_revenue"
        data={data}
        options={currencyOptions}
        footer={<Box fontSize="-1">Total revenue</Box>}
      />
      <KpiCard
        title={
          <Flex gap="3xs">
            {`Net Revenue ${ytdLabel}`}
            <InfoTooltip text={NET_REVENUE_INFO} />
          </Flex>
        }
        field="net_revenue"
        data={data}
        options={currencyOptions}
        footer={<Box fontSize="-1">Gross revenue less expenses</Box>}
      />
      <KpiCard
        title={`Expenses ${ytdLabel}`}
        field="expenses"
        data={data}
        options={currencyOptions}
        footer={
          <Box fontSize="-1">
            Direct, operating, integration and other costs, including Security
            and Maintenance
          </Box>
        }
      />
      {/* <KpiCard
        title={`Margin ${ytdLabel}`}
        field="margin"
        data={data}
        options={{ percentage: true }}
        footer={<Box fontSize="-1">Net Surplus / Gross Revenue</Box>}
      /> */}
    </Flex>
  );
}
